export default {
  not_localised: 'Acest document nu este încă disponibil în regiunea ta. Se afișează versiunea în engleză.',
};
